import React from 'react';
import { Container } from 'react-bootstrap';

import VendorDetailInfo from 'components/purchase-order/vendor/VendorDetails/VendorDetailInfo';
import VendorItems from 'components/purchase-order/vendor/VendorItems';

const VendorDetail = () => {
  return (
    <Container fluid className="p-0 d-flex flex-column gap-4">
      <VendorDetailInfo />

      <VendorItems />
    </Container>
  );
};

export default VendorDetail;
